import { Crud } from '../common/Edit';

/**
 * @desc 셋업프로젝트 > 일정관리 — TB_EELMB_PRJ_SCHD_M (프로젝트일정기본)
 * @author cnsglee
 * -------------------------------------------------------------------------------------
 *  Date.       author         Description
 * -------------------------------------------------------------------------------------
 * 2026.08.03   cnsglee        신규 생성 (외부 개발본 elm_dev → 레거시 컨벤션 적용)
 */

/** 업무유형코드 (공통코드 WKT_TP_CD 등록 필요: CARRY_IN 반입 / HOOKUP 훅업 / TURN_ON Turn On / IT_TEST IT Test) */
export const PRJ_SCHD_WKT_TP_CD = 'SCHD_WKT_TP_CD';
/** 일정상태코드 (공통코드 SCHD_STAT_CD 등록 필요: REG 등록 / CPLT 완료) */
export const PRJ_SCHD_STAT_CD = 'SCHD_STAT_CD';

export type PageType = 'calendar' | 'list';
export type EventStatus = 'delayed' | 'today' | 'normal' | 'complete';
export type ViewMode = 'month' | 'week' | 'day';

export interface CategoryConfig {
  id: string;
  label: string;
  tagPrefix: string;
}

export interface PrjScheduleCondition {
  elmPrjId?: string; // ELM프로젝트ID
  elmPrjIds?: any; // ELM프로젝트ID list
  wktTpCd?: string; // 업무유형코드
  schdNm?: string; // 제목 (부분일치)
  excpId?: string; // 협력업체ID
  excpIds?: any;
  tgtEqpId?: string; // 대상설비ID
  schdStatCd?: string; // 일정상태코드
  planStDtm?: string; // 조회 시작일자 (YYYYMMDD HH24:MI) — 일정 기간과 겹치면 포함
  planEndDtm?: string; // 조회 종료일자 (YYYYMMDD HH24:MI)
  delayYn?: string; // 지연 여부
}

export interface PrjSchedule extends Crud {
  schdId?: string; // 일정ID (PK)
  elmPrjId?: string; // ELM프로젝트ID
  elmPrjNm?: string; // ELM프로젝트명 (조회 조인)
  wktTpCd?: string; // 업무유형코드
  wktTpCdNm?: string; // 업무유형코드명
  schdNm?: string; // 일정명(제목)
  excpId?: string; // 협력업체ID
  excpAbbrNm?: string; // 협력업체약어
  excpNm?: string; // 협력업체명 (조회 조인 — TB_ELM_EXCP_M)
  eqpNm?: string; // 설비명 (조회 조인 — TB_EELMB_PRJ_TGT_EQP_M)
  prjSpCd?: string; // 프로젝트단계코드 (설비별 셋업 단계 연계용, 선택)
  planStDtm?: string; // 시작일자 (YYYYMMDD HH24:MI)
  planEndDtm?: string; // 종료일자 (YYYYMMDD HH24:MI)
  schdStatCd?: string; // 일정상태코드 (REG/CPLT)
  schdStatCdNm?: string; // 일정상태코드명
  schdCtn?: string; // 상세내용
  progMatrCtn?: string; // 진행사항내용 (줄 단위 누적)

  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값내용1
  optValCtn2?: string; // 옵션값내용2
  optValCtn3?: string; // 옵션값내용3
  optValCtn4?: string; // 옵션값내용4
  optValCtn5?: string; // 옵션값내용5

  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string; // 데이터입력사용자명
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string; // 데이터입력사용자명
  dataUpdDtm?: string; // 데이터수정일시

  tgtEqpList?: PrjScheduleEqp[];
  boxList?: PrjScheduleBox[];
  schdDisplayTitle?: string; // 캘린더 표시 타이틀
  schdProcYn?: string; // 완료/진행 체크 (타이틀 앞에 '!' 아이콘 처리 여부)
  delayYn?: string; // 지연 여부
}

export interface PrjScheduleEqp {
  schdId?: string;
  tgtEqpId?: string;
  elmPrjId?: string;
  cpltYn?: string;

  prdnProcCd?: string;
  prdnProcCdNm?: string;
  mcode?: string;
  eqpNm?: string;

  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값내용1
  optValCtn2?: string; // 옵션값내용2
  optValCtn3?: string; // 옵션값내용3
  optValCtn4?: string; // 옵션값내용4
  optValCtn5?: string; // 옵션값내용5

  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdDtm?: string; // 데이터수정일시
}

export interface PrjScheduleBox extends Crud {
  schdId?: string;
  pakBoxId?: string;
  elmPrjId?: string;
  cpltYn?: string;

  tgtEqpId?: string;
  pakBoxNo?: string;
  pakBoxNm?: string;
  mcodes?: string;
  bcdYn?: string;
  boxStatNm?: string;
  boxUnloDtm?: string;
  inptDtm?: string;
  abnormalYn?: string;

  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdDtm?: string; // 데이터수정일시
}
